const handleScrollTo = () => {
	$('.js-scroll-to').on('click', function(event) {
		const $targetElement = $($(this).attr('href'));

		if ($targetElement.length === 0) {
			return;
		}

		$('html, body').animate({ scrollTop: $targetElement.offset().top }, 400);

		event.preventDefault();
	});
}

handleScrollTo();
